import { type ReactNode } from 'react';

interface ArtifactCardProps {
  children: ReactNode;
  className?: string;
}

/**
 * Mystical card container styled as an ancient artifact
 * Used for login panel, dashboard sections, and modals
 */
export function ArtifactCard({ children, className = '' }: ArtifactCardProps) {
  return (
    <div
      className={`relative bg-gradient-to-b from-night/95 to-void/95 border border-stone/30 rounded-xl p-4 sm:p-6 backdrop-blur-sm shadow-2xl ${className}`}
    >
      {/* Decorative corner runes */}
      <div className="absolute top-2 left-2 text-rune/30 font-display text-xs">ᚠ</div>
      <div className="absolute top-2 right-2 text-rune/30 font-display text-xs">ᚢ</div>
      <div className="absolute bottom-2 left-2 text-rune/30 font-display text-xs">ᚦ</div>
      <div className="absolute bottom-2 right-2 text-rune/30 font-display text-xs">ᚨ</div>
      {children}
    </div>
  );
}
